
// Map alert types to image filenames
const sealImages = {
    "SÓDIO": "Sodio.png",
    "GORDURA SATURADA": "Gordura_Saturada.png",
    "AÇÚCAR ADICIONADO": "Acucar_Adicionado.png",
    "SÓDIO E GORDURA SATURADA": "Sodio_Gordura.png",
    "AÇÚCAR ADICIONADO E GORDURA SATURADA": "Acucar_Gordura.png",
    "AÇÚCAR ADICIONADO E SÓDIO": "Acucar_Sodio.png",
    "AÇÚCAR ADICIONADO, GORDURA SATURADA E SÓDIO": "Todos.png"
};

// Function to get the correct image based on the combination of nutrients
export const getSealImage = (nutrients) => {
    if (!nutrients || nutrients.length === 0) return null;

    // Sort to ensure consistent key matching
    const sortedNutrients = [...nutrients].sort();
    
    // Logic to find specific combination keys
    // Single
    if (sortedNutrients.length === 1) {
        if (sortedNutrients.includes("SÓDIO")) return sealImages["SÓDIO"];
        if (sortedNutrients.includes("GORDURA SATURADA")) return sealImages["GORDURA SATURADA"];
        if (sortedNutrients.includes("AÇÚCAR ADICIONADO")) return sealImages["AÇÚCAR ADICIONADO"];
    }
    
    // Double
    if (sortedNutrients.length === 2) {
        if (sortedNutrients.includes("SÓDIO") && sortedNutrients.includes("GORDURA SATURADA")) return sealImages["SÓDIO E GORDURA SATURADA"];
        if (sortedNutrients.includes("AÇÚCAR ADICIONADO") && sortedNutrients.includes("GORDURA SATURADA")) return sealImages["AÇÚCAR ADICIONADO E GORDURA SATURADA"];
        if (sortedNutrients.includes("AÇÚCAR ADICIONADO") && sortedNutrients.includes("SÓDIO")) return sealImages["AÇÚCAR ADICIONADO E SÓDIO"];
    }

    // Triple
    if (sortedNutrients.length === 3) {
        return sealImages["AÇÚCAR ADICIONADO, GORDURA SATURADA E SÓDIO"];
    }

    return null;
};
